// ══════════════════════════════════════════════════════════════════════════════
// SELDOR — ErrorBoundary
// Catches runtime errors and prevents white-screen crashes
// ══════════════════════════════════════════════════════════════════════════════

import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[Seldor] ErrorBoundary caught:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 40,
          background: '#060918',
          color: '#E8EAF6',
          fontFamily: "'Tajawal', 'Outfit', sans-serif",
          textAlign: 'center'
        }}>
          <div style={{
            width: 80,
            height: 80,
            borderRadius: 20,
            background: 'rgba(255, 76, 106, 0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 40,
            marginBottom: 20
          }}>
            ⚠️
          </div>
          <h2 style={{ margin: '0 0 10px', fontSize: 22, fontWeight: 700 }}>
            Something went wrong
          </h2>
          <p style={{ margin: '0 0 10px', color: '#8A8FB5', fontSize: 14, maxWidth: 500, lineHeight: 1.6 }}>
            حدث خطأ غير متوقع. نعتذر عن الإزعاج.
          </p>
          <p style={{ margin: '0 0 24px', color: '#5C6190', fontSize: 12, fontFamily: 'monospace', maxWidth: 600 }}>
            {this.state.error?.message || 'Unknown error'}
          </p>
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: '10px 20px',
                borderRadius: 8,
                background: 'transparent',
                color: '#00C0A3',
                border: '1px solid rgba(0, 192, 163, 0.25)',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'inherit'
              }}
            >
              Try Again
            </button>
            <button
              onClick={this.handleReload}
              style={{
                padding: '10px 20px',
                borderRadius: 8,
                background: '#00C0A3',
                color: '#fff',
                border: 'none',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'inherit'
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
